jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
	isTouch: function () {
		return window.matchMedia('(pointer: coarse)').matches; // hover: none funktioniert in Samsung Internet nicht. Empfohlener  Workaround ist pointer
	},

	isMouse: function () {
		return window.matchMedia('(pointer: fine)').matches;
	},

	prefersReducedMotion: function () {
		return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	},

	setCookie: function (name, value) {
		const exp = new Date();
		exp.setTime(exp.getTime() + 99 * 24 * 60 * 60 * 1000); // 99 Days

		const cookieString = `${name}=${value}; path=/; domain=${this.getTopLevelDomain()}; expires=${exp.toGMTString()};`;
		document.cookie = cookieString;
	},

	getCookie: function (name) {
		const ca = document.cookie.split(' ');
		if (typeof ca !== 'undefined') {
			for (let i = 0; i < ca.length; i++) {
				const kv = ca[i].split('=');
				if (kv[0] === name) {
					return kv.slice(1).join('=');
				}
			}
		}
		return null;
	},

	loadScript: function loadScript(script, callback) {
		const path = $j('#domPageVars').data('jsPath');
		const scriptTag = document.createElement('script');

		const isDevSystem = document.location.href.indexOf('.dev') > -1;
		let cacheBreakerForDevSystem = '';
		if (isDevSystem && $j('#domPageVars').data('useCacheBreaker') === true) {
			cacheBreakerForDevSystem = '?ts' + Date.now();
		}

		if (script.indexOf('https:') > -1) {
			scriptTag.setAttribute('src', script);
		} else {
			scriptTag.setAttribute('src', path + script + '.js' + cacheBreakerForDevSystem);
		}

		document.getElementsByTagName('head')[0].appendChild(scriptTag);
		if (!scriptTag.onloadDone && callback !== undefined) {
			scriptTag.onloadDone = true;
			scriptTag.onload = function () {
				callback();
			};
		}
	},

	vibrate: function () {
		if (typeof window.navigator.vibrate !== 'undefined') {
			window.navigator.vibrate(30);
		}
	},

	getTopLevelDomain: function () {
		const h = location.hostname;
		const n = h.match(/(.co.uk|.com.mx|.com.au)$/) ? -3 : -2;
		return h.split('.').slice(n).join('.');
	},

	getGetParamFromUrl: function getGetParamFromUrl(sParam) {
		const sPageURL = decodeURIComponent(window.location.search.substring(1));
		const sURLVariables = sPageURL.split('&');
		let sParameterName;
		let i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	},

	putCursorAtEnd: function putCursorAtEnd($input) {
		// Nur für no-touchevents weil iOS8 ein Problem mit dem reinklicken hat, wenn vorher ein Javascript focus() aufgerufen wurde.
		// http://stackoverflow.com/questions/26146252/in-ios8-using-focus-will-show-virtual-keyboard-and-scroll-page-after-touch
		if ($j('html.no-touchevents').length > 0) {
			const value = $input.val();
			$input.trigger('focus');
			$input.val('');
			$input.val(value);
		}
	},

	setFocusOnFirstFocusableElement: function ($domScope) {
		const focusableElementsString =
			'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable], summary';
		$domScope.filter(focusableElementsString).filter(':visible:not([aria-hidden=true])').first().trigger('focus');
	},

	/**
	 * serializes a form element to an object
	 * @param form {HTMLFormElement}
	 * @returns {{[key: string]: string | Array | object}}
	 */
	serializeForm: function (form) {
		const obj = {};
		const formData = new FormData(form);
		for (const key of formData.keys()) {
			const formDataValue = formData.getAll(key);
			obj[key] = fetchIt.tryParseJson(formDataValue.length === 1 ? formDataValue[0] : formDataValue);
		}
		return obj;
	},

	// Best usage: await jPar.util.awaitTimeout(1000);
	awaitTimeout: function (delay) {
		return new Promise((resolve) => setTimeout(resolve, delay));
	},

	waitForChildNodes: async function () {
		// wait a tick until all Child Nodes in a CustomElement are rendered // https://stackoverflow.com/questions/70949141/web-components-accessing-innerhtml-in-connectedcallback/70952159#70952159
		return new Promise(requestAnimationFrame);
	},

	getGlobalAbortSignal: function () {
		if (document.querySelector('peg-app-shell') !== null) {
			// All AppShell Pages
			const abortControllerSignal = document.querySelector('peg-app-shell')?.getAppShellAbortController().signal;
			if (abortControllerSignal !== undefined) {
				return abortControllerSignal;
			} else {
				jPar.util.log.error('getGlobalAbortSignal failed', 'AbortSignal was requested before AbortController was created');
				return null;
			}
		} else {
			// non AppShell Pages
			return new AbortController().signal;
		}
	},
});
